import React from 'react';
import { useHistory } from 'react-router-dom';
import ROUTES from '../../shared/constants/routes';

const NoAccessComponent = () => {
    const history = useHistory();

    const handleBackToLogin = () => {
        history.push(ROUTES.LANDING);
    };

    return (
        <div className="login-main">
            <a href="" onClick={(e) => e.preventDefault()} className="login-logo">
                <img
                    src={require('../../assets/images/niagara-logo-color-2-x.png')}
                    alt="Logo"
                />
            </a>
            <div className="login-form-container">
                <div className="no-access-message">
                    <h3>Access Not Authorized</h3>
                    <p>Your Niagara account was verified, but you do not have admin access to ARMA.</p>
                    <p>Please contact Jake Atachian (<a href="mailto:jatachian@niagarawater.com">jatachian@niagarawater.com</a>) to request access.</p>
                    <div className="login-btn">
                        <button className="btn-prmry" onClick={handleBackToLogin}>
                            Back to Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoAccessComponent;
